mutation RemoveAttachment($ids: [ID!]!) {
  removeAttachments(ids: $ids) {
    errors
    attachments {
      id
      deleted
    }
  }
}
